import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { ShowOnMapButton } from 'app/agriculture/components/ContentBox/components/ShowOnMapButton';
import { InfraType } from 'app/agriculture/mutations/types/entityConfig';
import { useEntity } from 'app/agriculture/queries/entities/useEntity';
import { AssetIcon } from 'app/agriculture/icons/components';
import { convertGeometryToMapLocation } from 'app/agriculture/components/utils/convertGeometryToLocation/convertGeometryToMapLocation';
import { TasksForEntity } from 'app/agriculture/infobox/tasks/TasksForEntity/TasksForEntity';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { NotesForEntitySkeleton } from 'app/agriculture/infobox/notes/NotesForEntitySkeleton';
import { NotesForEntity } from 'app/agriculture/infobox/notes/NotesForEntity';
import { TasksForEntitySkeleton } from 'app/agriculture/infobox/tasks/TasksForEntity/TasksForEntitySkeleton';
import { InfraSpecificContent } from 'app/agriculture/routes/Infra/components/InfraSpecificContent';
import { InfrastructureActions } from 'app/agriculture/infobox/InfrastructureActions';
import { GeometrySpecificContent } from 'app/agriculture/routes/Infra/components/GeometrySpecificContent';
import { convertMapLocationToPosition } from 'app/agriculture/components/utils/convertMapLocationToPosition';
import { ContentLayout } from 'app/agriculture/components/ContentLayout/ContentLayout';

interface InfraDetailsProps {
    infraType: InfraType;
    infraId: string;
}

export function InfraDetailsComponent({ infraType, infraId }: InfraDetailsProps) {
    const { name, geometry } = useEntity({ entityType: infraType, entityId: infraId });

    return (
        <ContentBox
            title={name}
            Icon={(props) => <AssetIcon {...props} name={infraType} />}
            showOnMapButton={
                <ShowOnMapButton
                    position={convertMapLocationToPosition(convertGeometryToMapLocation(geometry))}
                />
            }
            variant="lg"
        >
            <ContentBox.Section scrollable>
                <ContentBox.Section>
                    <ContentLayout>
                        <InfraSpecificContent infraType={infraType} />
                        <GeometrySpecificContent infraType={infraType} />
                        <SuspenseWrapper loadingComponent={<TasksForEntitySkeleton />}>
                            <TasksForEntity assetId={infraId} />
                        </SuspenseWrapper>
                    </ContentLayout>
                </ContentBox.Section>
                <SuspenseWrapper loadingComponent={<NotesForEntitySkeleton />}>
                    <NotesForEntity entityId={infraId} />
                </SuspenseWrapper>
                <InfrastructureActions sticky id={infraId} type={infraType} />
            </ContentBox.Section>
        </ContentBox>
    );
}
